var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.locationInfo)?_c('div',{staticClass:"ta-auction-location-information",domProps:{"innerHTML":_vm._s(_vm.locationInfo)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }